import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

export const ExportReactCSVReservation = async ({ data, report_name }) => {
    const temp = data['rows'];
    const csvData = [];

    function formatToYMD_HM(value) {
        if (!value || typeof value !== 'string') return "-";

        // Extract only date + hours:minutes
        const match = value.trim().match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/);
        if (match) {
            return `${match[1]} ${match[2]}`;
        }

        return "-";
    }

    for (let i = 0; i < temp.length; i++) {
        const row = {};
        const keys = Object.keys(temp[i]);

        for (let j = 0; j < keys.length; j++) {
            const key = keys[j];
            const value = temp[i][key];

            if (report_name === "Reservation Report" && ["Booking_Date_Time", "Cancelled_Date_Time"].includes(key)) {
                if (value.toString().trim() !== "-") {
                    row[key] = formatToYMD_HM(value)
                }else {
                    row[key] = "-";
                }
            } else if (report_name === "Reservation Report" && key === "name") {
                row[key] = value
                .toString()
                .replace(/[^a-z0-9\s]+/gi, "")
                .replace(/\s+/g, " ")
                .trim();
            } else {
                row[key] = value;
            }
        }
        csvData.push(row);
    }

    const csv = Papa.unparse(csvData);
    const zip = new JSZip();
    zip.file(`${report_name}.csv`, csv);

    const content = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: { level: 9 },
    });

    saveAs(content, `${report_name}.zip`);
};
